<template>
    <div class="scoreboard-phonetic-consonant">
        <span class="scoreboard-phonetic-consonant__text">{{ currentScore }}/1</span>
        <div class="scoreboard-phonetic-consonant__indicators">
            <span
                v-for="correctness, index in scorelist" :key="index"
                class="scoreboard-phonetic-consonant__indicator"
                :class="[
                    correctness === 1 ? 'scoreboard-phonetic-consonant__indicator--correct'   : '',
                    correctness === 0 ? 'scoreboard-phonetic-consonant__indicator--incorrect' : '',
                ]"></span>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            scorelist: { type: Array, default: [-1] },
        },

        computed: {
            currentScore(){
                let currentScore = 0;

                this.scorelist.forEach(correctness => {
                    if(correctness === 1){ currentScore++ }
                });

                return currentScore;
            }
        }
    };
</script>

<style scoped src="@/css/components/scoreboard-phonetic-consonant.css"></style>